import type { Dispatch, SetStateAction } from 'react';
import { cn } from '../cn';
import type { LikeHistoryEntry } from './types';


export interface LikesViewsSectionProps {
  viewsCount: number;
  handleToggleLike: () => void;
  isLiked: boolean;
  likePulseActive: boolean;
  setLikePulseActive: Dispatch<SetStateAction<boolean>>;
  likesHistory: LikeHistoryEntry[];
  setShowLikesHistory: Dispatch<SetStateAction<boolean>>;
  likesCount: number;
}

export default function LikesViewsSection({
  viewsCount,
  handleToggleLike,
  isLiked,
  likePulseActive,
  setLikePulseActive,
  likesHistory,
  setShowLikesHistory,
  likesCount,
}: LikesViewsSectionProps) {
  const hasLikesHistory = Boolean(likesHistory && likesHistory.length > 0);
  return (
    <div className="mt-lg mb-xl flex items-center justify-between gap-xl rounded-[10px] border border-white-alpha-10 bg-white-alpha-5 p-lg">
      {/* Views */}
      <div className="flex flex-1 items-center gap-md">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-white opacity-70"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <span className="[font-family:Lato,sans-serif] text-[14px] font-normal text-white opacity-80">
          {viewsCount}
        </span>
      </div>
      
      {/* Likes */}
      <div className="flex items-center gap-md">
        <button
          onClick={handleToggleLike}
          className="flex cursor-pointer items-center justify-center border-none bg-transparent p-xs opacity-100"
        >
          {isLiked ? (
            <span
              className="inline-block text-[20px] leading-none"
              style={{
                animation: likePulseActive ? 'likePulse 300ms ease-out' : 'none',
              }}
              onAnimationEnd={() => setLikePulseActive(false)}
            >
              ❤️
            </span>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-white opacity-70"
            >
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
          )}
        </button>
        <span
          onClick={() => {
            if (likesHistory && likesHistory.length > 0) {
              setShowLikesHistory(true);
            }
          }}
          className={cn(
            'min-w-2xl text-center [font-family:Lato,sans-serif] text-[14px] font-normal opacity-80',
            hasLikesHistory
              ? 'cursor-pointer text-gold underline'
              : 'cursor-default text-white no-underline',
          )}
        >
          {likesCount}
        </span>
      </div>
    </div>
  );
}
